import { Table } from "antd";
import React, { useLayoutEffect } from "react";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import { color } from '@amcharts/amcharts5';
const tranformData = (input) => {
  let originData = [
    {
      category: "Receptionist",
    },
    {
      category: "Optometrist",
    },
    {
      category: "Doctor",
    },
    {
      category: "Counsellor",
    },
    {
      category: "Nurse",
    },
  ];

  if (input) {
    const changeToArr = Object.values(input);
    const res2 = originData.map((el) => {
      const res = changeToArr.map((e: any, i) => {
        let categoryData;
        switch (el.category) {
          case "Receptionist":
            categoryData = {
              category: el.category,
              [Object.keys(input)?.[i]]: parseInt(e.tiepNhan),
            };
            break;
          case "Optometrist":
            categoryData = {
              category: el.category,
              [Object.keys(input)?.[i]]: parseInt(e.khucXa),
            };
            break;
          case "Doctor":
            categoryData = {
              category: el.category,
              [Object.keys(input)?.[i]]: parseInt(e.ngoaiTru),
            };
            break;
          case "Counsellor":
            categoryData = {
              category: el.category,
              [Object.keys(input)?.[i]]: parseInt(e.tuVan),
              displayName: parseInt(e.tuVan),
            };
            break;
          case "Nurse":
            categoryData = {
              category: el.category,
              [Object.keys(input)?.[i]]: parseInt(e.dieuDuong),
              displayName: parseInt(e.dieuDuong),
            };
            break;
          default:
            break;
        }
        return categoryData;
      });
      return res.reduce((acc, val) => Object.assign(acc, val), {});
    });

    originData = res2;
  }
  return originData;
};

export const renderChart = (dataChart, nam, root, type) => {
  let chart = root.container.children.push(
    am5xy.XYChart.new(root, {
      panX: false,
      panY: false,
      paddingLeft: 0,
      wheelX: "panX",
      wheelY: "zoomX",
      layout: root.verticalLayout,
    })
  );

  let data = tranformData(dataChart);

  // Create axes
  // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
  let xRenderer = am5xy.AxisRendererX.new(root, {
    cellStartLocation: 0.1,
    cellEndLocation: 0.9,
    minorGridEnabled: true,
  });

  let xAxis = chart.xAxes.push(
    am5xy.CategoryAxis.new(root, {
      categoryField: "category",
      renderer: xRenderer,
      tooltip: am5.Tooltip.new(root, {}),
    })
  );

  xRenderer.grid.template.setAll({
    location: 1,
  });
  xAxis.data.setAll(data);
  let yAxis = chart.yAxes.push(
    am5xy.ValueAxis.new(root, {
      renderer: am5xy.AxisRendererY.new(root, {
        strokeOpacity: 0.1,
      }),
      //max:1000
    })
  );
  // Add legend
  // https://www.amcharts.com/docs/v5/charts/xy-chart/legend-xy-series/
  let legend = chart.children.push(
    am5.Legend.new(root, {
      centerX: am5.p50,
      x: am5.p50,
    })
  );
  // Mảng màu cho từng tháng (ví dụ)
  const monthColors = [
    am5.color("#1F3964"), // Tháng 1
    am5.color("#558136"), // Tháng 2
    am5.color("#0DB050"), // Tháng 3
    am5.color("#FFBE00"), // Tháng 4
    am5.color("#5B9CD5"), // Tháng 5
    am5.color("#F145AA"), // Tháng 6
    am5.color("#264478"), // Tháng 7
    am5.color("#9E480E"), // Tháng 8
    am5.color("#636363"), // Tháng 9
    am5.color("#997100"), // Tháng 10
    am5.color("#FFFF00"), // Tháng 11
    am5.color("#A6A6A6"), // Tháng 12

  ];
  const monthColorss = [
    am5.color("#FFC0CB"), // Tháng 1
    am5.color("#FFC0CB"), // Tháng 2
    am5.color("#070707"), // Tháng 3
    am5.color("#070707"), // Tháng 4
    am5.color("#070707"), // Tháng 5
    am5.color("#070707"), // Tháng 6
    am5.color("#FFC0CB"), // Tháng 7
    am5.color("#FFC0CB"), // Tháng 8
    am5.color("#FFC0CB"), // Tháng 9
    am5.color("#070707"), // Tháng 10
    am5.color("#070707"), // Tháng 11
    am5.color("#FFC0CB"), // Tháng 12

  ];
  // Add series
  // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
  function makeSeries(name, fieldName, monthIndex) {
    let series = chart.series.push(
      am5xy.ColumnSeries.new(root, {
        name: name,
        xAxis: xAxis,
        yAxis: yAxis,
        valueYField: fieldName,
        categoryXField: "category",
      })
    );
    series.columns.template.setAll({
      tooltipText: "{valueY}",
      width: am5.percent(95),
      tooltipY: 0,
      strokeOpacity: 0,
      fill: monthColors[monthIndex],
    });
    if (type === 2|| type === 0) {
      series.bullets.push(function () {
        return am5.Bullet.new(root, {
          locationY: 0.9,
          sprite: am5.Label.new(root, {
            text: "{valueY}",
            centerY: am5.p50,
            centerX: 18,
            populateText: true,
            rotation: 90,
            fontWeight: "700",
            fill: monthColorss[monthIndex % 12]
          }),
        });
      });
    } else if (type === 3) {
      series.bullets.push(function () {
        return am5.Bullet.new(root, {
          locationY: 1.05,
          sprite: am5.Label.new(root, {
            text: "{valueY}",
            centerY: 22,
            centerX: am5.p50,
            populateText: true,
            rotation: 0,
            fontWeight: "700",
            fill: monthColorss[monthIndex % 12]
          }),
        });
      });
    }
    series.data.setAll(data);

    series.appear();

    legend.data.push(series);
  }

  makeSeries(`Jan - ${nam ?? ""}`, 1, 0);
  makeSeries(`Feb - ${nam ?? ""}`, 2, 1);
  makeSeries(`Mar - ${nam ?? ""}`, 3, 2);
  makeSeries(`Apr - ${nam ?? ""}`, 4, 3);
  makeSeries(`May - ${nam ?? ""}`, 5, 4);
  makeSeries(`Jun - ${nam ?? ""}`, 6, 5);
  makeSeries(`Jul - ${nam ?? ""}`, 7, 6);
  makeSeries(`Aug - ${nam ?? ""}`, 8, 7);
  makeSeries(`Sep - ${nam ?? ""}`, 9, 8);
  makeSeries(`Oct - ${nam ?? ""}`, 10, 9);
  makeSeries(`Nov - ${nam ?? ""}`, 11, 10);
  makeSeries(`Dec - ${nam ?? ""}`, 12, 11);

  // Set themes
  // https://www.amcharts.com/docs/v5/concepts/themes/
  root.setThemes([am5themes_Animated.new(root)]);

  chart.appear(1000, 100);
  root._logo.dispose();
  root.interfaceColors.set("grid", am5.color(0xff0000));
};
